<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">アンケート</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">{{ getTitle }}</h3>
    </div>
    <div class="page-block__inner">
      <div class="form-complete-area">
        <div class="form-complete-area__title">
          アンケートにご協力いただき<br class="sp">ありがとうございます
        </div>
        <div class="form-complete-area__lead">
          この度は、アンケートにご協力いただき、誠にありがとうございました。<br class="pc">

          ご回答いただきました内容は、「narasu」のサービス機能向上およびPR施策の参考情報として利用させていただきます。<br class="pc">

          なお、回答を集計したデータは公表いたしませんので、ご安心ください。
        </div>
        <div class="form-complete-area__text">
          ご質問や不明な点がある場合には、<router-link
            :to="{name:'contact'}"
            class="c-text-link">
            お問い合わせフォーム
          </router-link>よりお問い合わせください。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'SurveyComplete',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    getTitle() {
      return this.$route.params.title
    },
  },
}
</script>

<style scoped>
</style>
